/* eslint-disable @typescript-eslint/no-explicit-any */
export const registrations = [
    {
        name: 'Header',
        import: () => import('@stories/Widgets/Global/Header/Header'),
        config: {
            hydrate: 'eager',
        },
    },
    {
        name: 'Footer',
        import: () => import('@stories/Widgets/Global/Footer/Footer'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'GlobalStyles',
        import: () => import('@stories/Widgets/Global/GlobalStyles/GlobalStyles'),
        config: {
            hydrate: 'eager',
        },
    },
    {
        name: 'KenticoForm',
        import: () => import('@stories/Components/Misc/Forms/KenticoForm/KenticoForm'),
        config: {
            hydrate: 'eager',
        },
    },
    {
        name: 'CompanyDetails',
        import: () => import('@stories/Widgets/CompanyDetails/CompanyDetails'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'BlogDetailHeader',
        import: () => import('@stories/Widgets/BlogDetailHeader/BlogDetailHeader'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'BlogListing',
        import: () => import('@stories/Widgets/BlogListing/BlogListing'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'NewsBlogCarousel',
        import: () => import('@stories/Widgets/NewsBlogCarousel/NewsBlogCarousel'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'Faqs',
        import: () => import('@stories/Widgets/Faqs/Faqs'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'FiftyFiftyBlock',
        import: () => import('@stories/Widgets/FiftyFiftyBlock/FiftyFiftyBlock'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'FormWithCta',
        import: () => import('@stories/Widgets/FormWithCta/FormWithCta'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'FullWidthCta',
        import: () => import('@stories/Widgets/FullWidthCta/FullWidthCta'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'InnerHeroBanner',
        import: () => import('@stories/Widgets/InnerHeroBanner/InnerHeroBanner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'HeroBannerWithPropertySearch',
        import: () => import('@stories/Widgets/HeroBannerWithPropertySearch/HeroBannerWithPropertySearch'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'RichText',
        import: () => import('@stories/Widgets/RichText/RichText'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'HtmlEmbed',
        import: () => import('@stories/Widgets/HtmlEmbed/HtmlEmbed'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'Signposts',
        import: () => import('@stories/Widgets/Signposts/Signposts'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'TabbedContent',
        import: () => import('@stories/Widgets/TabbedContent/TabbedContent'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'TwoColumnNumericalTable',
        import: () => import('@stories/Widgets/TwoColumnNumericalTable/TwoColumnNumericalTable'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'PropertyDetailsHeader',
        import: () => import('@stories/Widgets/PropertyDetailsHeader/PropertyDetailsHeader'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'AnimatedStatistics',
        import: () => import('@stories/Widgets/AnimatedStatistics/AnimatedStatistics'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'MortgageCalculator',
        import: () => import('@stories/Widgets/MortgageCalculator/MortgageCalculator'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'StampDutyCalculator',
        import: () => import('@stories/Widgets/StampDutyCalculator/StampDutyCalculator'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'Usp',
        import: () => import('@stories/Widgets/Usp/Usp'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'MyWinkworthForms',
        import: () => import('@stories/Widgets/MyWinkworthForms/MyWinkworthForms'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'QuickLinks',
        import: () => import('@stories/Widgets/QuickLinks/QuickLinks'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'Spacer',
        import: () => import('@stories/Widgets/Spacer/Spacer'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'InPageNav',
        import: () => import('@stories/Widgets/InPageNav/InPageNav'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'MyWinkworthSaved',
        import: () => import('@stories/Widgets/MyWinkworthSaved/MyWinkworthSaved'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'MeetTheTeam',
        import: () => import('@stories/Widgets/MeetTheTeam/MeetTheTeam'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'TestimonialCarousel',
        import: () => import('@stories/Widgets/TestimonialCarousel/TestimonialCarousel'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'SignpostCarousel',
        import: () => import('@stories/Widgets/SignpostCarousel/SignpostCarousel'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'GoogleReviewsCarousel',
        import: () => import('@stories/Widgets/GoogleReviewsCarousel/GoogleReviewsCarousel'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'HistoryTimeline',
        import: () => import('@stories/Widgets/HistoryTimeline/HistoryTimeline'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'PropertyListing',
        import: () => import('@stories/Widgets/PropertyListing/PropertyListing'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'PropertyCardCarousel',
        import: () => import('@stories/Widgets/PropertyCardCarousel/PropertyCardCarousel'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'RecentlyViewedProperties',
        import: () => import('@stories/Widgets/RecentlyViewedProperties/RecentlyViewedProperties'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'FindOfficeSearch',
        import: () => import('@stories/Widgets/FindOfficeSearch/FindOfficeSearch'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'OfficeContacts',
        import: () => import('@stories/Widgets/OfficeContacts/OfficeContacts'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'MicrositeBanner',
        import: () => import('@stories/Widgets/MicrositeBanner/MicrositeBanner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'BookValuationForm',
        import: () => import('@stories/Widgets/BookValuationForm/BookValuationForm'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'InTheArea',
        import: () => import('@stories/Widgets/InTheArea/InTheArea'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'PropertyCardList',
        import: () => import('@stories/Widgets/PropertyCardList/PropertyCardList'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'PropertyBlock',
        import: () => import('@stories/Widgets/PropertyBlock/PropertyBlock'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ShareLinks',
        import: () => import('@stories/Widgets/ShareLinks/ShareLinks'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'MediaWidget',
        import: () => import('@stories/Widgets/MediaWidget/MediaWidget'),
        config: {
            hydrate: 'in-view',
        },
    },
];
